export const breakpoints = {
    mediumMin: 'min-width: 600px',
    largeMin: 'min-width: 920px',
};
